import React, { useEffect, useRef, useState } from "react";
import LoadingDialog from "../../components/Common/LoadingDialog";
import { Container } from "reactstrap";
import { Box, Grid } from "@mui/material";
import registerBg from '../../assets/images/register-background.png';
import LogoWhite from '../../assets/images/logo-white.png';
import Logo from '../../assets/images/Logo.svg';
import { connect, useDispatch } from "react-redux";
import CustomButton from "../../components/Form/CustomButton";
import { useNavigate } from "react-router-dom";
import CustomStepper from "../../components/Form/CustomStepper";
import BusinessInfoForm from "./BusinessInfoForm";
import ProfileInfoForm from "./ProfileInfoForm";
import LocationInfoForm from "./LocationInfoForm";
import { registerUser, resetRegisterState } from "../../store/auth/register/actions";
import { getGeneral, getRegion, requestOtpUser } from "../../store/actions";
import Notification from "../../components/Common/Notification";
import moment from "moment";

const Register = ({ windowWidth, registerRes, requestOtp, regionList, stateList, countryList, error }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setIsLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [formObj, setFormObj] = useState({ postal_code: '', country_id: 192, state_id: '', region: '', address_line_2: "", address_line_1: "", city_id: '', google_map_link: '' });
    const [notification, setNotification] = useState({});
    const postcodeRef = useRef(formObj?.postal_code || '');

    useEffect(() => {
        dispatch(getGeneral());
    }, [])

    useEffect(() => {
        if (registerRes?.code === 'validate_success' || registerRes?.code === 'success') {
            handleNextPage();
            setIsLoading(false);
            dispatch(resetRegisterState());
        } else if (registerRes?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({ open: true, type: 'error', msg: 'Invalid field' });
        } else if (registerRes?.code === 'invalid_user') {
            setIsLoading(false);
            setNotification({ open: true, type: 'error', msg: registerRes?.message || registerRes?.data?.error_message || 'Error' });
        }
    }, [registerRes])

    useEffect(() => {
        if (requestOtp?.code === 'success') {
            setIsLoading(false);
            setNotification({ open: true, type: 'success', msg: 'OTP has been sent successfully' });
        } else if (requestOtp?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({ open: true, type: 'error', msg: requestOtp?.message || requestOtp?.errors?.phone || 'Failed to send OTP' });
        }
    }, [requestOtp])

    useEffect(() => {
        postcodeRef.current = formObj?.postal_code || '';
    }, [formObj?.postal_code]);

    const steps = ["Business Info", "Profile Setup", "Location"];

    const handleFormChange = (field, value, day) => {
        let tempObj = { ...formObj };
        if (field === 'openingHours') {
            let openingHoursArr = tempObj?.openingHours || [];
            const dayObject = openingHoursArr.find((item) => item?.day === value) || { day: value, isChecked: false };
            dayObject.isChecked = !dayObject.isChecked;
            dayObject.open_time = null;
            dayObject.close_time = null;
            if (!openingHoursArr.find((item) => item?.day === value)) {
                openingHoursArr.push(dayObject);
            }
            tempObj['openingHours'] = openingHoursArr;
        } else if (field === 'open_time' || field === 'close_time') {
            let openingHoursArr = tempObj?.openingHours || [];
            const dayObject = openingHoursArr.find((item) => item?.day === day) || { day: day, isChecked: false };
            dayObject[field] = value;
            if (!openingHoursArr.find((item) => item?.day === day)) {
                openingHoursArr.push(dayObject);
            }
            tempObj['openingHours'] = openingHoursArr;
        } else {
            tempObj[field] = value;
        }
        setFormObj(tempObj);
    }

    const handleSubmitCurrentForm = () => {
        setIsLoading(true);
        let payload = {};
        if (activeStep === 0) {
            payload = {
                step: 1,
                company_name: formObj?.company_name || '',
                registration_number: formObj?.registration_number || '',
                company_description: formObj?.company_description || '',
                operation_hours: formObj?.openingHours ? formObj?.openingHours.map(item => ({ day_of_week: item?.day, open_time: item?.open_time, close_time: item?.close_time })) : [],
                name: formObj?.name || '',
                email: formObj?.email || '',
                phone: formObj?.phone ? '65' + formObj?.phone : '',
                otp: formObj?.otp || '',
                otp_request_type: 'whatsapp',
            }
        } else if (activeStep === 1) {
            payload = {
                step: 2,
                logo_images: formObj?.logo_images ? [{ name: formObj.logo_images?.file_name || '', file: formObj.logo_images?.file_base64 || '' }] : [],
                banner_images: formObj?.banner_images ? formObj.banner_images?.map((item) => ({ name: item?.file_name || '', file: item?.file_base64 || '' })) : [],
                // dealer_description: formObj?.dealer_description || '',
            }
        } else if (activeStep === 2) {
            payload = {
                step: 3,
                address_line_1: formObj?.address_line_1 || '',
                address_line_2: formObj?.address_line_2 || '',
                country_id: formObj?.country_id || '',
                city: formObj?.city_id || '',
                postal_code: formObj?.postal_code || '',
                region: formObj?.region_id || '',
                google_map_link: formObj?.google_map_link || '',
            }
        } else {
            payload = {
                step: 'submit',
                company_name: formObj?.company_name || '',
                registration_number: formObj?.registration_number || '',
                company_description: formObj?.company_description || '',
                operation_hours: formObj?.openingHours ? formObj?.openingHours.map(item => ({ day_of_week: item?.day, open_time: item?.open_time, close_time: item?.close_time })) : [],
                name: formObj?.name || '',
                email: formObj?.email || '',
                phone: formObj?.phone ? '65' + formObj?.phone : '',
                otp: formObj?.otp || '',
                otp_request_type: 'whatsapp',
                logo_images: formObj?.logo_images ? [{ name: formObj.logo_images?.file_name || '', file: formObj.logo_images?.file_base64 || '' }] : [],
                banner_images: formObj?.banner_images ? formObj.banner_images?.map((item) => ({ name: item?.file_name || '', file: item?.file_base64 || '' })) : [],
                // dealer_description: formObj?.dealer_description || '',
                address_line_1: formObj?.address_line_1 || '',
                address_line_2: formObj?.address_line_2 || '',
                // state_id: formObj?.state_id || '',
                city: formObj?.city_id || '',
                postal_code: formObj?.postal_code || '',
                region: formObj?.region_id || '',
                country_id: formObj?.country_id || '',
                google_map_link: formObj?.google_map_link || '',
            }
        }
        dispatch(registerUser(payload));
    }

    const handleGetRegionByPostcode = () => {
        dispatch(getRegion({ postcode: postcodeRef.current || "" }));
    }

    const handleRequestOTP = () => {
        dispatch(resetRegisterState());
        if (!formObj?.phone) {
            setNotification({ open: true, msg: "Please enter your phone number", type: "error" });
            return;
        }
        setIsLoading(true);
        dispatch(requestOtpUser({ login_type: 'whatsapp', phone: formObj?.phone ? '65' + formObj?.phone : '', for_register: 1 }));
    }

    const handleNextPage = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep(activeStep + 1);
        } else {
            setActiveStep(activeStep + 1);
            //submit
        }
    }

    const handleGoBack = () => {
        if (activeStep > 0) {
            setActiveStep(activeStep - 1);
        } else {
            navigate('/login');
        }
    }

    const reviewContent = () => {
        // sort the opening hours by day order
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'PH'];
        let closedDays = days.filter(d => !formObj?.openingHours?.some(oh => oh.day === d)).map(d => ({ day: d }));
        const selectedCountryName = countryList?.find((country) => String(country?.id) === String(formObj?.country_id))?.name || formObj?.country_id || '';
        const sortedOpeningHours = [...(formObj?.openingHours || []), ...closedDays].sort((a, b) => {
            const daysOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Public Holiday'];
            return a?.day === 'PH' ? 7 : daysOrder.indexOf(moment(a?.day, 'ddd').format('dddd')) - (b?.day === 'PH' ? 7 : daysOrder.indexOf(moment(b?.day, 'ddd').format('dddd')));
        });

        // let city = countryList?.filter?.((x, idx) => x?.id === 1)?.[0]?.cities,
        //     region = regionList?.find(r => r.id === formObj?.region);

        return (
            <div>
                <div className="header-2">Review and Submit</div>
                <Grid container mt={3} spacing={0.5}>
                    <Grid item xs={12} className="text-bold">Dealer name</Grid>
                    <Grid item xs={12}>{formObj?.company_name}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Registration number / UEN</Grid>
                    <Grid item xs={12}>{formObj?.registration_number}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Opening hours</Grid>
                    <Grid item container spacing={2} xs={12}>
                        {
                            sortedOpeningHours.map((item, idx) => {
                                return (
                                    <>
                                        <Grid item lg={3} md={5} sm={6} xs={12}>{item?.day === 'PH' ? 'Public Holiday' : moment(item?.day, 'ddd').format('dddd')}</Grid>
                                        <Grid item lg={9} md={7} sm={6} xs={12}>
                                            {!item?.open_time && !item?.close_time && 'Closed'}
                                            {item?.open_time ? moment(item?.open_time, 'HH:mm').format('h:mma') : ''}
                                            {item?.close_time ? ` - ${moment(item?.close_time, 'HH:mm').format('h:mma')}` : ''}
                                        </Grid>
                                    </>
                                )
                            })
                        }
                    </Grid>
                    <Grid item xs={12} className="text-bold mt-2">Short business description</Grid>
                    <Grid item xs={12}>{formObj?.company_description || '-'}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Address</Grid>
                    <Grid item xs={12}>{formObj?.address_line_1} <br />{formObj?.address_line_2 ? `${formObj?.address_line_2}` : ''}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Postal Code</Grid>
                    <Grid item xs={12}>{formObj?.postal_code || '-'}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Region</Grid>
                    <Grid item xs={12}>{formObj?.region_id?.length > 0 ? formObj.region_id.map(id => regionList?.data?.find(region => region.id === id)?.name).filter(Boolean).join(', ') : ''}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">City</Grid>
                    <Grid item xs={12}>{formObj?.city_id || '-'}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Country</Grid>
                    <Grid item xs={12}>{selectedCountryName || '-'}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Google map link</Grid>
                    <Grid item xs={12}>{formObj?.google_map_link || '-'}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Contact name</Grid>
                    <Grid item xs={12}>{formObj?.name}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Contact email</Grid>
                    <Grid item xs={12}>{formObj?.email}</Grid>
                    <Grid item xs={12} className="text-bold mt-2">Phone number</Grid>
                    <Grid item xs={12}>{formObj?.phone}</Grid>
                </Grid>
            </div>
        )
    }

    const successContent = () => {
        return (
            <div className="d-flex align-items-center justify-content-center" style={{ height: '65vh' }}>
                <div className="text-center" style={{ color: '#2B2B2B' }}>
                    <div className="header-2">Registration Submitted Successfully</div>
                    <div className="subheader mt-4 mb-3">Thank you for registering with iAuto!</div>
                    <div className="subheader">Your account has been received and is now pending approval by our team. </div>
                    <div className="subheader mb-5">We’ll review your details and uploaded documents to ensure everything is complete.</div>
                    <CustomButton
                        title={'Go to homepage'}
                        press={() => navigate("/dashboard")}
                        borderStyle={'1px solid #1D1B1B'}
                        backgroundColor={'white'}
                        textColor={'#1D1B1B'}
                        padding={20}
                    />
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <div style={{ backgroundColor: '#F1F5F7', height: '100vh', fontSynthesis: 'none' }}>
                <LoadingDialog open={loading} />
                <Container fluid className="p-0">
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    <Grid container>
                        <Grid item lg={6} md={7} xs={12} style={{ backgroundColor: 'white', position: 'relative' }}>
                            <Box p={windowWidth <= 768 ? 2 : 5} pb={"100px"} sx={{ overflowY: 'auto', height: '100vh' }}>
                                <div style={windowWidth <= 768 && 'center' ? { display: 'flex', justifySelf: 'center', paddingTop: 40 } : {}}>
                                    <img src={Logo} alt="" height={windowWidth <= 768 ? 32 : 24} width={windowWidth <= 768 ? 82 : 62} />
                                </div>
                                <Box p={2} px={4} mt={5}>
                                    {
                                        activeStep < 3 &&
                                        <>
                                            <h1 className="header-2">Create a Business Account</h1>
                                            <CustomStepper
                                                steps={steps}
                                                activeStep={activeStep}
                                                marginTop={4}
                                            />
                                        </>
                                    }
                                    <Box mt={activeStep < 3 ? 4 : 0}>
                                        {activeStep === 0 && <BusinessInfoForm formObj={formObj} handleFormChange={handleFormChange} windowWidth={windowWidth} error={error} handleRequestOTP={handleRequestOTP} />}
                                        {activeStep === 1 && <ProfileInfoForm formObj={formObj} handleFormChange={handleFormChange} setNotification={setNotification} error={error} layoutWidth={windowWidth} />}
                                        {
                                            activeStep === 2 &&
                                            <LocationInfoForm
                                                formObj={formObj}
                                                handleFormChange={handleFormChange}
                                                error={error}
                                                postcodeRef={postcodeRef}
                                                handleGetRegionByPostcode={handleGetRegionByPostcode}
                                                regionList={regionList}
                                                stateList={stateList}
                                                countryList={countryList}
                                            />
                                        }
                                        {activeStep === 3 && reviewContent()}
                                        {activeStep === 4 && successContent()}
                                    </Box>
                                </Box>
                            </Box>
                            {
                                activeStep < 4 &&
                                <div className="position-absolute bottom-0 d-flex justify-content-between w-100 p-4" style={{ borderTop: '1px solid #E2E2E2', backgroundColor: 'white' }}>
                                    <CustomButton
                                        title={'Go Back'}
                                        press={() => handleGoBack()}
                                        borderStyle={'1px solid #1D1B1B'}
                                        backgroundColor={'white'}
                                        textColor={'#1D1B1B'}
                                        padding={20}
                                        width={windowWidth <= 768 && '100%'}
                                        marginRight={windowWidth <= 768 && 10}
                                    />
                                    <CustomButton
                                        title={`${activeStep === 4 ? 'Submit' : `Next: ${steps[activeStep + 1] || 'Review and submit'}`}`}
                                        press={() => handleSubmitCurrentForm()}
                                        padding={20}
                                        width={windowWidth <= 768 && '100%'}
                                    />
                                </div>
                            }
                        </Grid>
                        {
                            windowWidth > 768 &&
                            <Grid item lg={6} md={5} sm={4} xs={12} sx={{ position: 'relative' }}>
                                <img src={registerBg} style={{ objectFit: 'cover', height: '100vh', width: '100%', position: 'relative' }} />
                                <div className="position-absolute top-0 left-0  p-5" >
                                    <img src={LogoWhite} alt="" height="24" width={62} />
                                </div>
                                <div className='position-absolute bottom-0 left-0 p-5' style={{ color: 'white' }}>
                                    <div className='font-size-24 text-semibold'>
                                        Buy. Sell. Ride. All on iAuto.
                                    </div>
                                    <div >
                                        Sign in to browse, buy, or become a seller on iAuto.
                                    </div>
                                </div>
                            </Grid>
                        }
                    </Grid>
                </Container>
            </div>
        </React.Fragment>
    )
}

function mapStateToProps({ Login, Register, Layout, General }) {
    return {
        userData: Login?.verifyAdmin?.user?.data,
        userPermission: Login?.permissionArry,
        requestOtp: Login?.requestOtp,
        windowWidth: Layout.currentWidth,
        registerRes: Register?.registerRes,
        error: Register?.registerRes?.errors,
        regionList: General?.regionRegister,
        stateList: General?.states,
        countryList: General?.countries,
    };
}


export default connect(mapStateToProps)(Register);